<script setup>
import AdvancedBotManager from '@/views/apps/bot/list/AdvancedBotManager.vue';

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
  },
})
</script>

<template>
  <section>
    <AdvancedBotManager></AdvancedBotManager>
  </section>
</template>
